import PropTypes from 'prop-types'
import { Modal } from 'src/components/common/Modal'
import styled from 'styled-components'

import { useCallback, useEffect, useRef, useState } from 'react'
import { isNextDayAfter5AM, getTokyoTime } from 'src/lib/date'
import { removeNewlineCode } from 'src/lib/string'
import InnerHTML from 'dangerously-set-html-content'

import Speaker from 'src/assets/img/speaker.png'
import BtnClose from 'src/assets/img/white-btn-close.png'
import { useLocation } from 'react-router-dom'
import { useAuthState } from 'src/providers/AuthProviders'
import getNews from 'src/services/get/getNews'
import { useQuery } from 'react-query'
import { filterDisplayTips } from 'src/lib/news'

const TipsModal = (props) => {
  const { type, aiPromptStatus } = props
  const [isTipsModalOpen, setIsTipsModalOpen] = useState(false)
  const [isTipsDisplaySetting, setIsTipsDisplaySetting] = useState(false)
  const contentRef = useRef(null)
  const location = useLocation()
  const user = useAuthState()
  const news = useQuery('tips', () => getNews(user.id, 'tips'), {
    cacheTime: 0
  })
  const [tips, setTips] = useState([])
  const [countTips, setCountTips] = useState(0)

  useEffect(() => {
    const data = news?.data
    if (!data) return

    const pathname = location.pathname
    const isDmTalkDetail = /^\/talk_real\/detail\/\d+$/.test(pathname)
    if (isDmTalkDetail && aiPromptStatus !== 'event') return

    const storage = JSON.parse(localStorage.getItem('tips')) || {}
    const displayTips = filterDisplayTips(data, 'tips', pathname).filter((item) => {
      const storageKey = `${type}_${item.id}`
      if (!Object.keys(storage).includes(storageKey)) return true
      return isNextDayAfter5AM(new Date(storage[storageKey].time))
    })
    setTips(displayTips)
  }, [news.data, setTips, aiPromptStatus, type, location.pathname])

  useEffect(() => {
    if (tips.length > 0) {
      const scrollToTop = () => {
        if (!contentRef.current) return
        contentRef.current.scrollTop = 0
      }
      setTimeout(() => {
        scrollToTop()
      }, 100)
    }
  }, [contentRef, tips, countTips])

  useEffect(() => {
    if (countTips < tips.length) setIsTipsModalOpen(true)
  }, [setIsTipsModalOpen, tips, countTips])

  const handleTipsDisplaySetting = useCallback(
    (e) => {
      if (e) e.stopPropagation()
      const currentTip = tips[countTips]

      if (isTipsDisplaySetting && currentTip?.id) {
        const storage = JSON.parse(localStorage.getItem('tips')) || {}
        const saveStorageData = JSON.stringify({
          ...storage,
          [`${type}_${currentTip.id}`]: { time: getTokyoTime(), isSetting: true }
        })
        localStorage.setItem('tips', saveStorageData)
      }

      setIsTipsDisplaySetting(false)
      setCountTips((prev) => prev + 1)
    },
    [isTipsDisplaySetting, countTips, tips, type]
  )

  return (
    <>
      {countTips < tips.length && (
        <Modal
          open={isTipsModalOpen}
          onClose={() => null}
          className="z-[9999] w-[85%] sm:w-[350px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 shadow-xl transform transition-all font-Inter rounded-xl overflow-y-auto bg-[#EEF6FF]"
        >
          <div
            onClick={handleTipsDisplaySetting}
            className="w-5 aspect-square absolute top-2 right-2 cursor-pointer z-[1002]"
          >
            <img src={BtnClose} alt="" />
          </div>
          <ModalBody>
            <div className="w-full flex flex-col items-center justify-center rounded-md">
              <ModalTitle>
                <p className="relative z-[1000]">{tips[countTips]?.name}</p>
                <img src={Speaker} className="absolute top-2 left-2/3" />
              </ModalTitle>
              <div
                ref={contentRef}
                className="h-80 font-Inter font-light text-xs text-black text-justify leading-6 overflow-y-auto whitespace-pre-line hidden-scroll"
              >
                {tips.map((item, index) => (
                  <div key={item.id || index}>
                    {countTips === index && <InnerHTML html={removeNewlineCode(item.content)} />}
                  </div>
                ))}
              </div>
            </div>
            {tips[countTips]?.displaySetting && (
              <div className="w-full h-12 flex font-bold justify-center items-center text-cornflower-blue">
                <input
                  className="mr-1 bg-sky-blue"
                  type="checkbox"
                  onChange={() => setIsTipsDisplaySetting(!isTipsDisplaySetting)}
                  checked={isTipsDisplaySetting}
                />
                <p className="text-xs">次の午前5時まで表示しない</p>
              </div>
            )}
          </ModalBody>
        </Modal>
      )}
    </>
  )
}

TipsModal.propTypes = {
  type: PropTypes.string.isRequired,
  aiPromptStatus: PropTypes.string
}

export default TipsModal

const ModalBody = styled.div.attrs({
  className: 'w-full relative bg-light-gray'
})`
  background-size: 100% 100%;
`

const ModalTitle = styled.div.attrs({
  className:
    'w-full min-h-[68px] px-8 py-[7px] relative text-center text-white text-xl font-semibold font-Inter leading-[24.2px] mx-4 py-4 z-[1000]'
})`
  background: linear-gradient(94.15deg, #6f9bff 26.03%, #9ac8ff 67.73%);
  background-size: 100% 100%;
`
